import { Accessor, createMemo } from "solid-js";
import { BrandL2WebstoreTelescopeRouteData } from "../data/brandl2_webstore_telescope_route_data";
import { FAQ } from "~/data/static_faqs/types";
import { openModalV2, goBack } from "~/shared_states/modal";
import { useTelescopeContext } from "@hubble/telescope";
import { SimilarBrandCardData } from "~/server/types/brand";
import { useWebstorePayment } from "./use_webstore_payment";

export function useBrandl2WebstoreTelescope(
  routeData: Accessor<BrandL2WebstoreTelescopeRouteData>
) {
  const { components } = useTelescopeContext();

  const brand = createMemo(() => routeData().brand);

  const simulateData = createMemo(() => routeData().simulate);

  function getMetaTitle(): string {
    const baseDiscountPercent =
      simulateData()?.discountDetails?.hubbleBaseDiscount?.percentage ?? 0;

    if (baseDiscountPercent > 0) {
      if (brand().rewardType !== "POSTPAID") {
        return `${brand().voucherProductMetadata.title} | Flat ${baseDiscountPercent}% Off | E-Gift Card | No Promo Code Needed`;
      } else {
        return `${brand().voucherProductMetadata.title} | E-Gift Card | Redeem benefit in Hubble App`;
      }
    } else {
      return `${brand().voucherProductMetadata.title} | E-Gift Card | No Promo Code Needed`;
    }
  }

  function getFaqs(): FAQ[] {
    return routeData().brandExtraMetadata.faqs ?? [];
  }

  function getCtaCopy(): string {
    return "Get this card";
  }

  function getSimilarBrands(): SimilarBrandCardData[] {
    return routeData().brandExtraMetadata.similarBrands?.slice(0, 20) ?? [];
  }

  // Integrate with webstore payment hook
  const {
    onClickGetThisCard,
    getDenominationList,
    showFullPageLoadingOverlay,
    ctaState,
    setCtaState,
  } = useWebstorePayment({
    brand: () => brand(),
  });

  const brandDescription = () =>
    routeData().brandExtraMetadata.brandDescription || "";

  const showFootnotesSection = () => {
    return routeData().brandExtraMetadata.footNotes.length > 0;
  };

  return {
    brand,
    getMetaTitle,
    getFaqs,
    getCtaCopy,
    onClickGetThisCard,
    getDenominationList,
    showFullPageLoadingOverlay,
    ctaState,
    setCtaState,
    simulateData,
    getSimilarBrands,
    brandDescription,
    showFootnotesSection,
  };
}
